import { render, staticRenderFns } from "./SplitRuleManage.vue?vue&type=template&id=51899a2c&scoped=true"
import script from "./SplitRuleManage.vue?vue&type=script&lang=js"
export * from "./SplitRuleManage.vue?vue&type=script&lang=js"
import style0 from "./SplitRuleManage.vue?vue&type=style&index=0&id=51899a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51899a2c",
  null
  
)

export default component.exports